import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { observer } from 'mobx-react';
// locals
import { toP } from '../../util';
import Tooltip from '../../Tooltip';
var en = function en(n) {
  return n.toLocaleString('en-US');
};
var TooltipContents = React.forwardRef(function (_ref, ref) {
  var model = _ref.model,
    feature = _ref.feature;
  var start = feature.get('start');
  var end = feature.get('end');
  var refName = feature.get('refName');
  var coord = start === end ? en(start) : "".concat(en(start), "..").concat(en(end));
  var sources = feature.get('sources');
  var source = feature.get('source');
  var summary = feature.get('summary');
  var obj = Object.fromEntries(model.sources.map(function (ent) {
    return [ent.name, ent];
  }));
  return React.createElement("div", {
    ref: ref
  }, [refName, coord].filter(function (f) {
    return !!f;
  }).join(':'), React.createElement("br", null), sources ? React.createElement("table", null, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "color"), React.createElement("th", null, "source"), React.createElement("th", null, "score"))), React.createElement("tbody", null, Object.entries(sources).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      source = _ref3[0],
      data = _ref3[1];
    var _a;
    return React.createElement("tr", {
      key: source
    }, React.createElement("td", {
      style: {
        background: (_a = obj[source]) === null || _a === void 0 ? void 0 : _a.color
      }
    }, " "), React.createElement("td", null, source), React.createElement("td", null, toP(data.score)));
  }))) : React.createElement("span", null, source, ' ', summary ? "min:".concat(toP(feature.get('minScore')), " avg:").concat(toP(feature.get('score')), " max:").concat(toP(feature.get('maxScore'))) : toP(feature.get('score'))));
});
var WiggleTooltip = observer(function (props) {
  return React.createElement(Tooltip, _objectSpread({
    useClientY: true,
    TooltipContents: TooltipContents
  }, props));
});
export default WiggleTooltip;
export { Tooltip };